import { Button, Select } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { useAuthData } from '~/hooks/auth/use-auth-data';
import { api } from '~/trpc-extra/api';

export default function ChangeTeamForm() {
  const updateTeam = api.team.updateActiveTeam.useMutation();
  const { activeOrg, orgHelper } = useAuthData();
  const orgs = orgHelper?.getOrgs();

  const form = useForm({
    initialValues: {
      orgId: activeOrg?.orgId,
    },
    validate: {
      orgId: (x) => (x && orgs?.map((x) => x.orgId).includes(x) ? null : 'Invalid org'),
    },
  });

  return (
    <form
      onSubmit={form.onSubmit(async ({ orgId }) => {
        if (!orgId) {
          return;
        }
        try {
          await updateTeam.mutateAsync({ teamId: orgId });
          // Lazy way to kick user back to the front (to avoid permission issues)
          if (window.location.href === window.location.origin) {
            window.location.reload();
          } else {
            window.location.replace(window.location.origin);
          }
        } catch (e) {
          console.error(e);
          notifications.show({
            message: `Unable to change org: ${e}`,
            color: 'red',
          });
        }
      })}
    >
      <Select
        label="Org Name"
        placeholder="Org Name"
        defaultValue={activeOrg?.orgId}
        data={orgs?.map((x) => ({ value: x.orgId, label: x.orgName }))}
        searchable
        {...form.getInputProps('orgId')}
      />
      <Button
        fullWidth
        type="submit"
        mt="md"
      >
        Change Active Team
      </Button>
    </form>
  );
}
